import React from 'react';
import dynamic from 'next/dynamic';
import { Loader } from '@/components';
import { MetaData } from '@/containers';

const ContactsPage = dynamic(() => import('../../layouts/ContactsPage'), {
	loading: () => <Loader />,
});

const ReturnProcess = () => {
	return (
		<>
			<MetaData
				title='Контакты FH.BY'
				description='Контактная информация интернет-магазина брендовой одежды FH.BY. Звоните ☏ +375 (17) 310-5-389'
			/>
			<ContactsPage />
		</>
	);
};

ReturnProcess.getInitialProps = () => {
	return {};
};

export default ReturnProcess;
